function getUserInfo() {
    try {
        return JSON.parse(localStorage.userInfo || '{}');
    } catch (error) {
        return {};
    }
}

function normalizePermission(item) {
    if (!item) return [];
    if (typeof item === 'string') return [item];
    return [item.code, item.name, item.permission, item.functionCode].filter(Boolean);
}

export function getPermissionList() {
    const user = getUserInfo();
    const candidates = [
        user.functionList,
        user.functions,
        user.permissionList,
        user.permissions,
        user.roleFunctions,
    ];

    return candidates
        .filter(Array.isArray)
        .reduce((result, list) => result.concat(list), [])
        .reduce((result, item) => result.concat(normalizePermission(item)), []);
}

export function hasFunction(permission) {
    if (!permission) return false;
    return getPermissionList().includes(permission);
}

export function hasAnyFunction(permissions) {
    if (!Array.isArray(permissions) || permissions.length === 0) return false;
    return permissions.some(permission => hasFunction(permission));
}

export function hasAllFunction(permissions) {
    if (!Array.isArray(permissions) || permissions.length === 0) return false;
    return permissions.every(permission => hasFunction(permission));
}

function normalizeRoleId(roleId) {
    return roleId === undefined || roleId === null ? '' : String(roleId);
}

export function getRoleId() {
    const user = getUserInfo();
    return normalizeRoleId(user.roleId);
}

export function hasRoleId(roleId) {
    return getRoleId() === normalizeRoleId(roleId);
}

export function hasAnyRoleId(roleIds) {
    if (!Array.isArray(roleIds) || roleIds.length === 0) return false;
    const currentRoleId = getRoleId();
    return roleIds.map(normalizeRoleId).includes(currentRoleId);
}

export const visitPermissions = {
    dataInput: 'visit:data:input',
    dataView: 'visit:data:view',
    dataExport: 'visit:data:export',
    subjectManage: 'visit:subject:manage',
    dataArea: 'visit:data:area',
    auditIntegrity: 'visit:audit:integrity',
    auditView: 'visit:audit:view',
};
